<template>
  <div class="profile-sidebar">
    <q-list class="profile-sidebar__menu" padding>
      <q-item
        v-for="(tab, index) in visibleTabs"
        :key="index"
        clickable
        :active="activeTab === tab.key"
        active-class="profile-sidebar__item--active"
        class="profile-sidebar__menu-item"
        @click="navigateToTab(tab.route)"
      >
        <q-item-section avatar class="profile-sidebar__icon-container">
          <q-icon :name="tab.icon" size="sm" />
        </q-item-section>
        <q-item-section class="profile-sidebar__label">{{ tab.label }}</q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script>
/**
 * Component used for the profile page sidebar navigation
 */
export default {
  name: 'ProfileSidebar',
  props: {
    /**
     * Currently active tab
     */
    activeTab: {
      type: String,
      required: true
    },
    clientRole: {
      type: String,
      default: 'viewer'
    }
  },
  data() {
    return {
      tabs: [
        {
          key: 'personal_information',
          label: 'Personal information',
          icon: 'o_person',
          roles: ['admin', 'user', 'manager', 'viewer'],
          route: 'personal-information'
        },
        {
          key: 'account_security',
          label: 'Account security',
          icon: 'o_security',
          route: 'account-security',
          roles: ['admin', 'user', 'manager', 'viewer']
        },
        /* Temporarily disabled
        {
          key: 'billing_payments',
          label: 'Billing & payments',
          icon: 'o_credit_card',
          route: 'billing-payments',
          roles: ['admin', 'manager']
        },
        */
        {
          key: 'teams',
          label: 'Teams',
          icon: 'o_groups',
          route: 'teams',
          roles: ['admin', 'manager']
        }
      ]
    };
  },
  methods: {
    /**
     * Navigate to the selected tab route, avoiding duplicate navigation
     */
    navigateToTab(routeName) {
      // Prevent navigation to current route
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    }
  },
  computed: {
    /**
     * Filters tabs based on user's role
     */
    visibleTabs() {
      return this.tabs.filter(tab => tab.roles.includes(this.clientRole));
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-sidebar {
  width: 100%;

  &__menu {
    padding: 0;
  }

  &__menu-item {
    border-radius: 6px;
    margin-bottom: 8px;
    padding: 10px 16px;
    height: 100%;
    @include inter-font($size: 16px, $bolded: false, $color: var(--main-text-color));
    gap: 16px;
    transition: all 0.2s ease;
  }

  &__icon-container {
    min-width: 24px;
  }

  &__label {
    padding: 0;
  }

  &__item--active {
    background-color: var(--terziary-btn-color) !important;
    @include inter-font($size: 16px, $bolded: true, $color: var(--main-text-color));

    .q-icon {
      color: var(--main-text-color);
    }
  }
}
</style>
